export const routesRaporIk = [
  {
    path: "/rapor_ik",
    name: "rapor_ik",
    component: () => import("@/views/mesai/rapor_ik/index.vue"),
    meta: {
      public: false,
      title: "mesai.IK Rapor",
      yetki: { k: [1012402] },
    },
  },
]
